<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Plan',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/product/plan/Index.vue